import { useColorModeValue } from "@chakra-ui/react";

export function useTileColors() {
  // Tile Color for filed status counts
  const noAlarmBgColor = useColorModeValue("#B7E1C3", "#264E36");

  // Status colot for not serious alarms
  const yellowBgColor = useColorModeValue("#F5EBA3", "#c7a20cff");

  // Status color for critical alarms
  const redBgColor = useColorModeValue("#F5A3A3", "#78281F");

  //Device tile representing users device count
  const deviceTileBgColor = useColorModeValue("#e2d4d4ff", "#7a7575ff");

  return { noAlarmBgColor, yellowBgColor, redBgColor, deviceTileBgColor };
}
